export enum Role {
  Admin = 'Admin',
  Client = 'Cliente',
  Colaborador = 'Colaborador',
  Comercial = 'Comercial',
  Manager = 'Gestor'
}
